import { render, staticRenderFns } from "./BulletinIndexComponent.vue?vue&type=template&id=523f224b&scoped=true&"
import script from "./BulletinIndexComponent.vue?vue&type=script&lang=js&"
export * from "./BulletinIndexComponent.vue?vue&type=script&lang=js&"
import style0 from "./BulletinIndexComponent.vue?vue&type=style&index=0&id=523f224b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f224b",
  null
  
)

export default component.exports